module.exports = __webpack_public_path__ + "static/media/periodicTable.094b2420.png";